export { default } from './SeguroAuto25Cotacao';
